// Copyright 2019 Sorama B.V.

import { OpenIdConnectConfiguration } from "aurelia-open-id-connect";
import { Api } from "libraries/WebApi/Api";
import { Log, UserManagerSettings, WebStorageStateStore } from "oidc-client";

export const oidConfiguration: OpenIdConnectConfiguration = {
    loginRedirectRoute: "/",
    logoutRedirectRoute: "/",
    unauthorizedRedirectRoute: "/unauthorized",
    logLevel: Log.NONE,
    userManagerSettings: <UserManagerSettings>{
        authority: Api.authority,
        automaticSilentRenew: true,
        // The interval in milliseconds between checking the user's session.
        checkSessionInterval: 10000,
        // The client or application ID that the authority issues.
        client_id: "SoramaSISPortal",
        post_logout_redirect_uri: `${window.location.origin}/signout-oidc`,
        redirect_uri: `${window.location.origin}/signin-oidc`,
        response_type: "id_token token",
        scope: "openid profile SoramaWebApi SoramaComputeApi",

        // number of millisecods to wait for the authorization
        // server to response to silent renew request
        silentRequestTimeout: 10000,
        silent_redirect_uri: `${window.location.origin}/signin-silent-oidc`,
        userStore: new WebStorageStateStore({
            prefix: "oidc",
            store: window.localStorage,
        }),
    },
};
